import React from 'react'

const ProfileEditButton = ({ handler }) => {
  return (
    <button type='button' className='profile-form__row-button' onClick={handler}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.66634 10.5H4.99967C4.0792 10.5 3.33301 11.2462 3.33301 12.1667C3.33301 13.0872 4.0792 13.8334 4.99967 13.8334H13.333C14.2535 13.8334 14.9997 14.5796 14.9997 15.5C14.9997 16.4205 14.2535 17.1667 13.333 17.1667H9.99967M12.4997 10.5L9.99967 10.5V8L14.9997 3L17.4997 5.49995L12.4997 10.5Z" stroke="#AAABAB" strokeWidth="1.6" strokeLinecap="square" />
      </svg>
      Edit
    </button>
  )
}

export default ProfileEditButton
